export const isDefaultColor = (
    color: string,
    defaultColors = ['rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', '#000000', '#000'],
): boolean => {
    return defaultColors.includes(color);
};
